import { companyListLockReducer } from "../reducer/CompanyListLockReducer";

export const reducer = companyListLockReducer;